module.exports = __webpack_public_path__ + "img/good.df46c05b.png";